module.exports = __webpack_public_path__ + "static/media/school.a0772540.svg";